"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayStats = void 0;
var auto_1 = __importDefault(require("chart.js/auto"));
require("./indexs.scss");
var ParseDataStats_1 = require("./ParseDataStats");
var DisplayStats = /** @class */ (function () {
    function DisplayStats() {
        this.parseDataStats = new ParseDataStats_1.ParseDataStats();
        this.currentChartType = "pie";
        this.number = 20;
    }
    // Méthode displayStats permet d'afficher les statistiques
    DisplayStats.prototype.displayStats = function (bindings, resultsEl, translations) {
        // Vérification si le nombre de clés dans bindingset est égal à 1
        if (Object.keys(bindings[0]).length === 1 || bindings.length === 1) {
            this.displayNumber(bindings, resultsEl);
        }
        else {
            if (bindings.length !== 1) {
                // Sinon, on affiche les charts selon le choix de l'utilisateur
                this.displayCharts(bindings, resultsEl, this.currentChartType, translations);
            }
        }
    };
    //methode displaycharts qui propose un switch avec les methode displayPie et displayBar et displayDoughnut et display Polar
    DisplayStats.prototype.displayCharts = function (bindings, resultsEl, chartType, translations) {
        switch (chartType) {
            case "pie":
                this.displayPie(bindings, resultsEl, translations);
                break;
            case "bar":
                this.displayBar(bindings, resultsEl, translations);
                break;
            case "doughnut":
                this.displayDoughnut(bindings, resultsEl, translations);
                break;
            case "polar":
                this.displayPolar(bindings, resultsEl, translations);
                break;
        }
    };
    //methode displayDropdownList qui permet d'afficher un dropdown list pour choisir le type de chart
    DisplayStats.prototype.displayDropdownList = function (bindings, resultsEl, translations) {
        var _this = this;
        var dropdownList = document.createElement("select");
        dropdownList.classList.add("chart-dropdown");
        // Options for the dropdown
        var options = [
            { value: "pie", text: "".concat(translations["pie"]) },
            { value: "bar", text: "".concat(translations["bar"]) },
            { value: "doughnut", text: "".concat(translations["doughnut"]) },
            { value: "polar", text: "".concat(translations["polar"]) },
        ];
        options.forEach(function (option) {
            var optionElement = document.createElement("option");
            optionElement.value = option.value;
            optionElement.textContent = option.text;
            dropdownList.appendChild(optionElement);
        });
        // Event listener for change
        dropdownList.addEventListener("change", function () {
            _this.currentChartType = dropdownList.value;
            _this.displayCharts(bindings, resultsEl, _this.currentChartType, translations);
        });
        // Set initial selected option
        dropdownList.value = this.currentChartType;
        resultsEl.appendChild(dropdownList);
        return dropdownList;
    };
    //methode generateColors qui permet de generer des couleurs pour les charts
    DisplayStats.prototype.generateColors = function (count) {
        var colors = [];
        for (var i = 0; i < count; i++) {
            var hue = Math.floor((360 / count) * i);
            colors.push("hsl(".concat(hue, ", 70%, 50%)"));
        }
        return colors;
    };
    //methode qui permet de choisir la quantité des elements à afficher propose 4 valeur 5 10 20 40
    DisplayStats.prototype.chosenQuantity = function (bindings, resultsEl, translations) {
        var _this = this;
        var dropdownList = document.createElement("select");
        dropdownList.classList.add("chart-dropdown");
        // Options for the dropdown
        var options = [
            { value: "5", text: "5" },
            { value: "10", text: "10" },
            { value: "20", text: "20" },
            { value: "25", text: "25" },
        ];
        options.forEach(function (option) {
            var optionElement = document.createElement("option");
            optionElement.value = option.value;
            optionElement.textContent = option.text;
            dropdownList.appendChild(optionElement);
        });
        // Event listener for change
        dropdownList.addEventListener("change", function () {
            //convert the value to number
            _this.number = parseInt(dropdownList.value);
            _this.displayCharts(bindings, resultsEl, _this.currentChartType, translations);
        });
        // Set initial selected option
        dropdownList.value = this.number.toString();
        resultsEl.appendChild(dropdownList);
        return dropdownList;
    };
    //methode displayPie qui permet d'afficher un pie chart
    DisplayStats.prototype.displayPie = function (bindings, resultsEl, translations) {
        var _a, _b;
        var labels = [];
        var data = [];
        //recuperer les données avec l'utilisation de la methode extractdata de la classe ParseDataStats
        var parsedData = this.parseDataStats.extractdata(bindings);
        //recuperer les valeur selon la quantité demandée par l'utilisateur
        var dataF = this.parseDataStats.extractOnlyDataNeeded(parsedData, this.number, translations);
        console.log("DataF :", dataF);
        //recuperer les labels et les valeurs
        for (var _i = 0, dataF_1 = dataF; _i < dataF_1.length; _i++) {
            var bindingSet = dataF_1[_i];
            //cela nous permet d'etre plus sur de la valeur de label et de value pour chaque bindingSet
            labels.push((_a = bindingSet.label) !== null && _a !== void 0 ? _a : "");
            // a changer de mettre value as 0 si value est null !!!
            (_b = data.push(bindingSet.value)) !== null && _b !== void 0 ? _b : 0;
        }
        //generer les couleurs pour le chart selon la longueur des données
        var backgroundColors = this.generateColors(data.length);
        //les données du chart labels et dataSets
        var chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColors,
                    borderWidth: 1,
                    hoverOffset: 8,
                },
            ],
        };
        // Effacer le contenu précédent
        resultsEl.innerHTML = "";
        var containerCentre = document.createElement("div");
        containerCentre.classList.add("chart-center");
        //creation du contenu html pour le chart
        var container = document.createElement("div");
        container.classList.add("pie-chart-container");
        var contain = document.createElement("div");
        contain.classList.add("contain");
        // Create and append the "Quantity to display :" text
        var textquantity = document.createElement("p");
        textquantity.textContent = "".concat(translations["quantity"]);
        contain.appendChild(textquantity);
        // Create and append the quantity dropdown
        var buttonQuantity = document.createElement("select");
        buttonQuantity.classList.add("cc");
        buttonQuantity = this.chosenQuantity(bindings, resultsEl, translations);
        contain.appendChild(buttonQuantity);
        // Create and append the chart type dropdown
        var button = document.createElement("select");
        button.classList.add("chart-dropdown");
        button = this.displayDropdownList(bindings, resultsEl, translations);
        contain.appendChild(button);
        // Append the container to the main container
        container.appendChild(contain);
        var canvas = document.createElement("canvas");
        canvas.classList.add("chart-pie");
        container.appendChild(canvas);
        containerCentre.appendChild(container);
        resultsEl.appendChild(containerCentre);
        //creation du chart
        new auto_1.default(canvas, {
            type: "pie",
            data: chartData,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: "right",
                        labels: {
                            boxWidth: 20,
                            padding: 10,
                        },
                    },
                    title: {
                        display: false,
                        text: "Pie Chart",
                        position: "top",
                        align: "center",
                    },
                },
            },
        });
    };
    //same methods of pie chart we will change only the type of chart type:'Bar'
    DisplayStats.prototype.displayBar = function (bindings, resultsEl, translations) {
        var _a, _b;
        var labels = [];
        var data = [];
        var parsedData = this.parseDataStats.extractdata(bindings);
        var dataF = this.parseDataStats.extractOnlyDataNeeded(parsedData, this.number, translations);
        console.log("DataF :", dataF);
        for (var _i = 0, dataF_2 = dataF; _i < dataF_2.length; _i++) {
            var bindingSet = dataF_2[_i];
            labels.push((_a = bindingSet.label) !== null && _a !== void 0 ? _a : "");
            (_b = data.push(bindingSet.value)) !== null && _b !== void 0 ? _b : 0;
        }
        var backgroundColors = this.generateColors(data.length);
        var chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColors,
                    borderWidth: 1,
                    hoverOffset: 8,
                },
            ],
        };
        resultsEl.innerHTML = ""; // Effacer le contenu précédent
        var containerCentre = document.createElement("div");
        containerCentre.classList.add("chart-center");
        var container = document.createElement("div");
        container.classList.add("pie-chart-container");
        var contain = document.createElement("div");
        contain.classList.add("contain");
        // Create and append the "Quantity to display :" text
        var textquantity = document.createElement("p");
        textquantity.textContent = "".concat(translations["quantity"]);
        contain.appendChild(textquantity);
        // Create and append the quantity dropdown
        var buttonQuantity = document.createElement("select");
        buttonQuantity.classList.add("cc");
        buttonQuantity = this.chosenQuantity(bindings, resultsEl, translations);
        contain.appendChild(buttonQuantity);
        // Create and append the chart type dropdown
        var button = document.createElement("select");
        button.classList.add("chart-dropdown");
        button = this.displayDropdownList(bindings, resultsEl, translations);
        contain.appendChild(button);
        // Append the container to the main container
        container.appendChild(contain);
        var canvas = document.createElement("canvas");
        canvas.classList.add("chart-pie");
        container.appendChild(canvas);
        containerCentre.appendChild(container);
        resultsEl.appendChild(containerCentre);
        new auto_1.default(canvas, {
            type: "bar",
            data: chartData,
            options: {
                responsive: true,
                plugins: {
                    title: {
                        display: false,
                        text: "Bar Chart",
                        position: "top",
                        align: "center",
                    },
                },
            },
        });
    };
    DisplayStats.prototype.displayDoughnut = function (bindings, resultsEl, translations) {
        var _a, _b;
        var labels = [];
        var data = [];
        var parsedData = this.parseDataStats.extractdata(bindings);
        var dataF = this.parseDataStats.extractOnlyDataNeeded(parsedData, this.number, translations);
        console.log("DataF :", dataF);
        for (var _i = 0, dataF_3 = dataF; _i < dataF_3.length; _i++) {
            var bindingSet = dataF_3[_i];
            labels.push((_a = bindingSet.label) !== null && _a !== void 0 ? _a : "");
            (_b = data.push(bindingSet.value)) !== null && _b !== void 0 ? _b : 0;
        }
        var backgroundColors = this.generateColors(data.length);
        var chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColors,
                    borderWidth: 1,
                    hoverOffset: 8,
                },
            ],
        };
        resultsEl.innerHTML = ""; // Effacer le contenu précédent
        var containerCentre = document.createElement("div");
        containerCentre.classList.add("chart-center");
        var container = document.createElement("div");
        container.classList.add("pie-chart-container");
        var contain = document.createElement("div");
        contain.classList.add("contain");
        // Create and append the "Quantity to display :" text
        var textquantity = document.createElement("p");
        textquantity.textContent = "".concat(translations["quantity"]);
        contain.appendChild(textquantity);
        // Create and append the quantity dropdown
        var buttonQuantity = document.createElement("select");
        buttonQuantity.classList.add("cc");
        buttonQuantity = this.chosenQuantity(bindings, resultsEl, translations);
        contain.appendChild(buttonQuantity);
        // Create and append the chart type dropdown
        var button = document.createElement("select");
        button.classList.add("chart-dropdown");
        button = this.displayDropdownList(bindings, resultsEl, translations);
        contain.appendChild(button);
        // Append the container to the main container
        container.appendChild(contain);
        var canvas = document.createElement("canvas");
        canvas.classList.add("chart-pie");
        container.appendChild(canvas);
        containerCentre.appendChild(container);
        resultsEl.appendChild(containerCentre);
        new auto_1.default(canvas, {
            type: "doughnut",
            data: chartData,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: "right",
                        labels: {
                            boxWidth: 20,
                            padding: 10,
                        },
                    },
                    title: {
                        display: false,
                        text: "Doughnut Chart",
                        position: "top",
                        align: "center",
                    },
                },
            },
        });
    };
    DisplayStats.prototype.displayPolar = function (bindings, resultsEl, translations) {
        var _a, _b;
        var labels = [];
        var data = [];
        var parsedData = this.parseDataStats.extractdata(bindings);
        var dataF = this.parseDataStats.extractOnlyDataNeeded(parsedData, this.number, translations);
        console.log("DataF :", dataF);
        for (var _i = 0, dataF_4 = dataF; _i < dataF_4.length; _i++) {
            var bindingSet = dataF_4[_i];
            labels.push((_a = bindingSet.label) !== null && _a !== void 0 ? _a : "");
            (_b = data.push(bindingSet.value)) !== null && _b !== void 0 ? _b : 0;
        }
        var backgroundColors = this.generateColors(data.length);
        var chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: backgroundColors,
                    borderWidth: 1,
                    hoverOffset: 8,
                },
            ],
        };
        resultsEl.innerHTML = ""; // Effacer le contenu précédent
        var containerCentre = document.createElement("div");
        containerCentre.classList.add("chart-center");
        var container = document.createElement("div");
        container.classList.add("pie-chart-container");
        var contain = document.createElement("div");
        contain.classList.add("contain");
        // Create and append the "Quantity to display :" text
        var textquantity = document.createElement("p");
        textquantity.textContent = "".concat(translations["quantity"]);
        contain.appendChild(textquantity);
        // Create and append the quantity dropdown
        var buttonQuantity = document.createElement("select");
        buttonQuantity.classList.add("cc");
        buttonQuantity = this.chosenQuantity(bindings, resultsEl, translations);
        contain.appendChild(buttonQuantity);
        // Create and append the chart type dropdown
        var button = document.createElement("select");
        button.classList.add("chart-dropdown");
        button = this.displayDropdownList(bindings, resultsEl, translations);
        contain.appendChild(button);
        // Append the container to the main container
        container.appendChild(contain);
        var canvas = document.createElement("canvas");
        canvas.classList.add("chart-pie");
        container.appendChild(canvas);
        containerCentre.appendChild(container);
        resultsEl.appendChild(containerCentre);
        new auto_1.default(canvas, {
            type: "polarArea",
            data: chartData,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: "right",
                        labels: {
                            boxWidth: 20,
                            padding: 10,
                        },
                    },
                    title: {
                        display: false,
                        text: "Polar Chart",
                        position: "top",
                        align: "center",
                    },
                },
            },
        });
    };
    DisplayStats.prototype.displayNumber = function (bindings, resultsEl) {
        var _a;
        resultsEl.innerHTML = ""; // Effacer le contenu précédent
        //column for our dataStats
        var dataColumn = "";
        var labelColumn = "";
        //loop through the bindings to identify the columns
        for (var _i = 0, bindings_1 = bindings; _i < bindings_1.length; _i++) {
            var bindingSet = bindings_1[_i];
            for (var key in bindingSet) {
                //check if the column is a label or data
                if (!((_a = bindingSet[key]) === null || _a === void 0 ? void 0 : _a.label)) {
                    //the key is the column name
                    console.log("key :", key);
                    dataColumn = key;
                }
                else {
                    //the key is the column name
                    console.log("key :", key);
                    labelColumn = key;
                }
            }
        }
        var container = document.createElement("div");
        container.classList.add("result-container-pie");
        var box = document.createElement("div");
        box.classList.add("result-box-pie");
        var valueDiv = document.createElement("div");
        valueDiv.classList.add("result-value-pie");
        for (var _b = 0, bindings_2 = bindings; _b < bindings_2.length; _b++) {
            var bindingSet = bindings_2[_b];
            for (var key in bindingSet) {
                valueDiv.textContent = bindingSet[dataColumn].value;
            }
        }
        box.appendChild(valueDiv);
        container.appendChild(box);
        resultsEl.appendChild(container);
    };
    return DisplayStats;
}());
exports.DisplayStats = DisplayStats;
